import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-new-case-search-clients-header',
    templateUrl: './new-case-search-clients-header.component.html',
    styleUrls: ['./new-case-search-clients-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewCaseSearchClientsHeaderComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
